module.exports = __webpack_public_path__ + "img/hashtag_white.4aa9c482.svg";